import { type ButtonProps } from '@mui/material/Button';

const ICON_SIZES: Record<NonNullable<ButtonProps['size']>, number> = {
  large: 24,
  medium: 22,
  small: 18,
};

export const calculateIconSize = (size: ButtonProps['size']): number => {
  if (!size) {
    return ICON_SIZES.medium;
  }
  return ICON_SIZES[size] || ICON_SIZES.medium;
};
